import { render } from "./MyPageNavigator.vue?vue&type=template&id=324ee4c2"
import script from "./MyPageNavigator.vue?vue&type=script&lang=js"
export * from "./MyPageNavigator.vue?vue&type=script&lang=js"

import "./MyPageNavigator.vue?vue&type=style&index=0&id=324ee4c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__